import { ProfileView as Profile} from './Profile';
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { withRouter } from "react-router-dom";
import { actionSetListNotification } from '@/redux/actions';

// const mapStateToProps = (state) => ({...state})

const mapStateToProps = ({ NotificationReducer }) => ({
   $store: {
      NotificationReducer,
   },
});
const mapDispatchToProps = (dispatch) => ({
   $action: bindActionCreators(
      {
         actionSetListNotification: actionSetListNotification
      },
      dispatch
   ),
});

//export default connect(mapStateToProps)(withRouter(Home));

//export const HomeView: any = connect(mapStateToProps,NotificationsAction)(withRouter(Home));

export const ProfileView: any = compose(
   withRouter,
   connect(mapStateToProps, mapDispatchToProps)
)(Profile);
